export const mutationUserGenerateSignature = `
mutation ProductRecommendationPublicURLCreate($userId: ID!) {
  productRecommendationPublicURLCreate(user_id: $userId) {
    expiresAt
    isNoExpiry
    signature
  }
}
`